import type { KnowledgeResponse, KnowledgeType } from "entities/knowledge/types";
import type { ErrorMeta } from "types/redux";

export enum PinAddRejectActionTypes {
  FETCH_PINNED_KNOWLEDGE = "[Topic] Fetch Pinned Knowledge",
  FETCH_PINNED_KNOWLEDGE_FULFILLED = "[Topic] - Fetch Pinned Knowledge Fulfilled",
  FETCH_PINNED_KNOWLEDGE_REJECTED = "[Topic] - Fetch Pinned Knowledge Rejected",
  UPDATE_PINNED_KNOWLEDGE = "[Topic] Update Pinned Knowledge",
  UPDATE_PINNED_KNOWLEDGE_FULFILLED = "[Topic] Update Pinned Knowledge Fulfilled",
  UPDATE_PINNED_KNOWLEDGE_REJECTED = "[Topic] Update Pinned Knowledge Rejected",
  REJECT_KNOWLEDGE = "[Topic] Reject Knowledge",
  REJECT_KNOWLEDGE_FULFILLED = "[Topic] Reject Knowledge Fulfulled",
  REJECT_KNOWLEDGE_REJECTED = "[Topic] Reject Knowledge Rejected",
  RESET_ADDED_KNOWLEDGE = "[Knowledge] Reset Knowledge",
  APPROVE_KNOWLEDGE = "[Knowledge] Approve Knowledge",
  APPROVE_KNOWLEDGE_FULFILLED = "[Knowledge] Approve Knowledge Fulfilled",
  APPROVE_KNOWLEDGE_REJECTED = "[Knowledge] Approve Knowledge Rejected",
  FETCH_TOPICS_FOR_PINNED_KNOWLEDGE = "[Knowledge] Fetch Topics for Pinned Knowledge",
  FETCH_TOPICS_FOR_PINNED_KNOWLEDGE_FULFILLED = "[Knowledge] Fetch Topics for Pinned Knowledge Fulfilled",
  FETCH_TOPICS_FOR_PINNED_KNOWLEDGE_REJECTED = "[Knowledge] Fetch Topics for Pinned Knowledge Rejected",
}

export type FetchTopicPinnedKnowledge = {
  meta: { topicId: string; page?: number; limit?: number; forceRefresh?: boolean };
  type: PinAddRejectActionTypes.FETCH_PINNED_KNOWLEDGE;
};

export type FetchTopicPinnedKnowledgeFulfilled = {
  meta: { topicId: string; page?: number; limit?: number };
  payload: { data: KnowledgeResponse[] };
  type: PinAddRejectActionTypes.FETCH_PINNED_KNOWLEDGE_FULFILLED;
};

export type FetchTopicPinnedKnowledgeRejected = {
  meta: { topicId: string; page?: number; limit?: number };
  type: PinAddRejectActionTypes.FETCH_PINNED_KNOWLEDGE_REJECTED;
};

export type UpdateTopicPinnedKnowledge = {
  meta: {
    topicId: string;
    knowledgeId: string;
    knowledgeType: KnowledgeType;
    isPinned: boolean;
  };
  type: PinAddRejectActionTypes.UPDATE_PINNED_KNOWLEDGE;
};

export type UpdateTopicPinnedKnowledgeFulfilled = {
  meta: {
    topicId: string;
    knowledgeId: string;
    isPinned: boolean;
  };
  type: PinAddRejectActionTypes.UPDATE_PINNED_KNOWLEDGE_FULFILLED;
};

export type UpdateTopicPinnedKnowledgeRejected = {
  meta: ErrorMeta & { topicId: string; knowledgeId: string; isPinned: boolean };
  type: PinAddRejectActionTypes.UPDATE_PINNED_KNOWLEDGE_REJECTED;
};

export type RejectTopicKnowledge = {
  meta: ErrorMeta & {
    knowledgeId: string;
    knowledgeType: KnowledgeType;
    onSuccessPath?: string;
    rejectionReason: string;
    topicId: string;
  };
  type: PinAddRejectActionTypes.REJECT_KNOWLEDGE;
};

export type RejectTopicKnowledgeFulfilled = {
  meta: { knowledgeId: string };
  type: PinAddRejectActionTypes.REJECT_KNOWLEDGE_FULFILLED;
};

export type RejectTopicKnowledgeRejected = {
  meta: { knowledgeId: string };
  type: PinAddRejectActionTypes.REJECT_KNOWLEDGE_REJECTED;
};

export type ApproveKnowledge = {
  meta: { knowledgeId: string; onSuccess?: () => void };
  type: PinAddRejectActionTypes.APPROVE_KNOWLEDGE;
};

export type ApproveKnowledgeFulfilled = {
  meta: { knowledgeId: string };
  type: PinAddRejectActionTypes.APPROVE_KNOWLEDGE_FULFILLED;
};

export type ApproveKnowledgeRejected = {
  meta: ErrorMeta & { knowledgeId: string };
  type: PinAddRejectActionTypes.APPROVE_KNOWLEDGE_REJECTED;
};

export type FetchTopicsForPinnedKnowledge = {
  meta: ErrorMeta & { knowledgeId: string; forceRefresh?: boolean };
  type: PinAddRejectActionTypes.FETCH_TOPICS_FOR_PINNED_KNOWLEDGE;
};

export type FetchTopicsForPinnedKnowledgeFulfilled = {
  meta: { knowledgeId: string };
  payload: { topicIds: string[] };
  type: PinAddRejectActionTypes.FETCH_TOPICS_FOR_PINNED_KNOWLEDGE_FULFILLED;
};

export type FetchTopicsForPinnedKnowledgeRejected = {
  meta: ErrorMeta & { knowledgeId: string };
  type: PinAddRejectActionTypes.FETCH_TOPICS_FOR_PINNED_KNOWLEDGE_REJECTED;
};

export type PinAddRejectAction =
  | FetchTopicPinnedKnowledge
  | FetchTopicPinnedKnowledgeFulfilled
  | FetchTopicPinnedKnowledgeRejected
  | UpdateTopicPinnedKnowledge
  | UpdateTopicPinnedKnowledgeFulfilled
  | UpdateTopicPinnedKnowledgeRejected
  | RejectTopicKnowledge
  | RejectTopicKnowledgeFulfilled
  | RejectTopicKnowledgeRejected
  | ApproveKnowledge
  | ApproveKnowledgeFulfilled
  | ApproveKnowledgeRejected
  | FetchTopicsForPinnedKnowledge
  | FetchTopicsForPinnedKnowledgeFulfilled
  | FetchTopicsForPinnedKnowledgeRejected;
